module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/OIS光学式手ブレ補正モジュール.a315fb7d.png";